export default class IframeMessenger {

  constructor(options) {
    if (!options) {
      throw new Error('No configuration provided')
    }

    let targetWindow = options.targetWindow
    if (targetWindow) {
      if (targetWindow.constructor === String) {
        targetWindow = document.querySelector(targetWindow)
      }

      targetWindow = targetWindow.contentWindow ? targetWindow.contentWindow : targetWindow

      if (targetWindow.constructor.name !== 'Window') {
        throw new Error('Target window required invalid')
      }
    }

    let sequence = 0

    this.getNextRequestID = function () {
      return 'REQ_' + (sequence++).toString(36)
    }

    window.addEventListener(
      'message',
      event => {
        let data
        try {
          data = JSON.parse(event.data)
        } catch (e) {}
        this.onMessage(data, event.source)
      },
      false
    )

    this.options = options
    this.targetWindow = targetWindow
    this.requestMap = {}
    this.unsentRequests = []
  }

  _message(message, targetWindow = this.targetWindow) {
    targetWindow.postMessage(
      JSON.stringify(message),
      this.options.targetOrigin || '*'
    )
  }

  onMessage(message, sourceWindow) {
    if (!message) {
      return
    }

    const id = message.id,
      request = message.request,
      response = message.response

    if (request) {
      const reqHandler = this.options.onMessage
      if (reqHandler) {
        reqHandler(response => {
          this._message({
            id: id,
            response: response
          }, sourceWindow)
        }, message.request)
      }

    } else if (response) {
      const callback = this.requestMap[id].callback
      delete this.requestMap[id]
      callback(response)
    }
  }

  message(callback, request) {
    const targetWindow = this.targetWindow

    if (!targetWindow) {
      throw new Error('No Target Window specified')
    }

    /*
    const readyState = targetWindow.document.readyState,
      currentURL = targetWindow.location.href

    if (readyState !== 'complete' || currentURL.indexOf('about:') === 0) {
      if (!this.onLoad) {
        this.onLoad = event => {
          let item
          while (item = this.unsentRequests.pop()) {
            this.message(item.callback, item.request)
          }
        }
        targetWindow.addEventListener('load', this.onLoad)
      }

      this.unsentRequests.push({
        callback: callback,
        request: request
      })
      return
    }
    */

    const id = this.getNextRequestID(),
      indexedRequest = {
        id: id,
        request: request,
        callback: callback
      }
    this.requestMap[id] = indexedRequest
    this._message({
      id: indexedRequest.id,
      request: indexedRequest.request
    })
  }
}